import { useMemo } from 'react';
import { CustomPrimaryMenu } from '../components/CustomPrimaryMenu/CustomPrimaryMenu.js';
import {
  DefaultPrimaryMenuMobile,
  DefaultSideMenu,
  DefaultSideMenuMobile,
  DefaultWorkspaceMenu,
  DefaultWorkspaceMenuMobile,
} from '@cld-remote/application_wrapper/index';

export const useApplicationWrapper = (isMobile: boolean) => {
  return useMemo(
    () => ({
      SideMenu: isMobile ? DefaultSideMenuMobile : DefaultSideMenu,
      PrimaryMenu: isMobile ? DefaultPrimaryMenuMobile : CustomPrimaryMenu,
      WorkspaceMenu: isMobile ? DefaultWorkspaceMenuMobile : DefaultWorkspaceMenu,
    }),
    [isMobile]
  );
};
